import React from "react";
import style from "../ModalJobs/style.module.css";
import lang from "../../../../lang/lang";
import { useSelector } from "react-redux";

const ModalError = ({ onClose, message }) => {
  const currentLanguage = useSelector(({ main }) => main.currentLanguage);
  const t = lang[currentLanguage] || lang.hy || {};
  const text = message || t.cv_error_generic;

  return (
    <div className={style.modal_jobs_content_title}>
      <div onClick={() => onClose(false)} className={style.modal_jobs_close}>
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16M16 1L1 16" stroke="#282828"></path>
        </svg>
      </div>
      <div className={style.modal_jobs_error_icon} aria-hidden="true">
        !
      </div>
      <span className={style.modal_jobs_error_text}>{text}</span>
      <div
        onClick={() => onClose(false)}
        className={style.modal_jobs_content_button}>
        {t.cv_ok_close || t.to_close}
      </div>
    </div>
  );
};

export default ModalError;
